import { useState, useEffect } from "react";
import { Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import SuperAdminProtectedRoute from './components/SuperAdminProtectedRoute.jsx'
import Login from './pages/Login.jsx'
import Dashboard from './pages/Dashboard.jsx'
import ReceiptEntryForm from './pages/ReceiptEntryForm.jsx'
import VouchersList from './pages/VouchersList.jsx'
import ReceiptList from './pages/ReceiptList.jsx'
import ReceiptEditForm from './pages/ReceiptEditForm.jsx'
import ReceiptSummaryList from './pages/ReceiptSummaryList.jsx'
import ReceiptReport from './pages/ReceiptReport.jsx'
import Profile from './pages/Profile.jsx'
import ChangePassword from './pages/ChangePassword.jsx'
import CustomerLedger from './pages/CustomerLedger.jsx'
import StockRegister from './pages/StockRegister.jsx'
import RentRegister from './pages/RentRegister.jsx'
import PartyWiseStatement from './pages/PartyWiseStatement.jsx'
import GatepassEntryForm from './pages/GatepassEntryForm.jsx'
import GatepassList from './pages/GatepassList.jsx'
import SuperAdminLogin from './pages/superadmin/SuperAdminLogin.jsx'
import SuperAdminDashboard from './pages/superadmin/SuperAdminDashboard.jsx'
import OrganizationsList from './pages/superadmin/OrganizationsList.jsx'
import CompaniesList from './pages/superadmin/CompaniesList.jsx'
import UsersList from './pages/superadmin/UsersList.jsx'
import AllUsersList from './pages/superadmin/AllUsersList.jsx'
import AllCompaniesList from './pages/superadmin/AllCompaniesList.jsx'
import Loader from './components/LoaderFull.jsx';
import InstallPrompt from './components/InstallPrompt.jsx';
import API from "./api/api"; 

export default function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Request interceptor
    const reqInterceptor = API.interceptors.request.use(config => {
      setLoading(true);
      return config;
    }, error => {
      setLoading(false);
      return Promise.reject(error);
    });

    // Response interceptor
    const resInterceptor = API.interceptors.response.use(response => {
      setLoading(false);
      return response;
    }, error => {
      setLoading(false);
      return Promise.reject(error);
    });

    // Cleanup
    return () => {
      API.interceptors.request.eject(reqInterceptor);
      API.interceptors.response.eject(resInterceptor);
    };
  }, []);
  return (
    <>
      {loading && <Loader />}
      <InstallPrompt />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/receipts" element={<ProtectedRoute><ReceiptEntryForm /></ProtectedRoute>} />
      <Route path="/receipts/list" element={<ProtectedRoute><ReceiptList /></ProtectedRoute>} />
      <Route path="/receipts/edit/:id" element={<ProtectedRoute><ReceiptEditForm /></ProtectedRoute>} />
      <Route path="/vouchers/list" element={<ProtectedRoute><VouchersList /></ProtectedRoute>} />
      <Route path="/receipts/summary" element={<ProtectedRoute><ReceiptSummaryList /></ProtectedRoute>} />
      <Route path="/receipts/report" element={<ProtectedRoute><ReceiptReport /></ProtectedRoute>} />
      <Route path="/customer-ledger" element={<ProtectedRoute><CustomerLedger /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
      <Route path="/stock-register" element={<ProtectedRoute><StockRegister /></ProtectedRoute>} />
      <Route path="/rent-register" element={<ProtectedRoute><RentRegister /></ProtectedRoute>} />
      <Route path="/party-wise-statement" element={<ProtectedRoute><PartyWiseStatement /></ProtectedRoute>} />
      <Route path="/gatepass" element={<ProtectedRoute><GatepassEntryForm /></ProtectedRoute>} />
      <Route path="/gatepass/edit/:id" element={<ProtectedRoute><GatepassEntryForm /></ProtectedRoute>} />
      <Route path="/gatepass/list" element={<ProtectedRoute><GatepassList /></ProtectedRoute>} />
      {/* SuperAdmin Routes */}
      <Route path="/superadmin/login" element={<SuperAdminLogin />} />
      <Route path="/superadmin" element={<SuperAdminProtectedRoute><SuperAdminDashboard /></SuperAdminProtectedRoute>} />
      <Route path="/superadmin/organizations" element={<SuperAdminProtectedRoute><OrganizationsList /></SuperAdminProtectedRoute>} />
      <Route path="/superadmin/organizations/:organizationId/companies" element={<SuperAdminProtectedRoute><CompaniesList /></SuperAdminProtectedRoute>} />
      <Route path="/superadmin/organizations/:organizationId/users" element={<SuperAdminProtectedRoute><UsersList /></SuperAdminProtectedRoute>} />
      <Route path="/superadmin/companies" element={<SuperAdminProtectedRoute><AllCompaniesList /></SuperAdminProtectedRoute>} />
      <Route path="/superadmin/users" element={<SuperAdminProtectedRoute><AllUsersList /></SuperAdminProtectedRoute>} />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  )
}
